import React from "react";
import styled from "styled-components";

export default function PrivacyPolicyComponent(): React.ReactElement {
  const PageBox = styled.div`
    background-color: #0e1017;
    padding-top: 30px;
    background-image: url("/images/PrivacyPolicy/web-bg.svg");
    background-position: top;
    background-repeat: no-repeat;
    padding-bottom: 80px;

    // @media (max-width: 1280px) {
    //   font-size: 20px;
    //   margin: 0px 5px;
    // }
  `;

  const Container = styled.div`
    width: 80%;
    margin: auto;
    margin-top: 100px;
    // @media (max-width: 1280px) {
    //   font-size: 20px;
    //   margin: 0px 5px;
    // }
  `;

  const PrivacyContainer = styled.div`
    background-color: #14161f;
    margin: auto;
    border-radius: 13px;
    padding: 40px;
    overflow-wrap: break-word;
    color: rgb(84, 92, 110);

    & h1 {
      color: white;
      margin: 40px 0px;
      font-size: 20px;
    }
  `;

  const Header = styled.h4`
    display: flex;
    width: 100%;
    font-family: "N B";
    font-size: 30px;
    color: rgb(255, 255, 255);
    margin-bottom: 1rem;
    position: relative;
  `;

  const DateText = styled.h4`
    color: rgb(84, 92, 110);
    font-size: 12px;
  `;

  return (
    <PageBox>
      <Container>
        <Header>Privacy Policy</Header>
        <DateText>Date of last modification: 14.10.2023. at 08:00 CET (UTC+1)</DateText>
        <PrivacyContainer>
          <div>
            <h1>Privacy Policy</h1>
            <p>Last updated: 14 October 2023 </p>
            <p>
              This Privacy Policy discloses the privacy practices of WGTV INC, our offices,
              subsidiaries, and associated companies, our offices, subsidiaries, and associated
              companies (“WRewards,” “we” or “us”). WRewards receives, collects, stores and manages
              personal information according to the following Privacy Policy, with the goal of
              incorporating the “Privacy by Design” approach. When collecting your personal
              information, WRewards ensures the secure storage of your data by taking appropriate
              security measures to prevent unauthorized access, disclosure, modification, or
              unauthorized destruction of personal information. For the purpose of this Privacy
              Policy, WRewards is the data controller. By using our website https://wrewards.com/
              (“Website”), you agree to the terms and conditions of this Privacy Policy. This
              Privacy Policy forms a binding agreement between WRewards and you, being our customer,
              partner, or user.
            </p>
            <p>Information for California Residents:</p>
            <p>
              If you are a California resident, please refer to the “Additional Information for
              California Residents” below.
            </p>
          </div>
          <div>
            <h1>1. Data Collected</h1>
            <p>Data that you voluntarily provide us with:</p>
            <p>
              1.1.1 You may provide us with your personal information in a number of ways,
              including, without limitation, when you:
            </p>
            <p>
              register for our services, contact us to purchase our products or in relation to any
              business matter;
            </p>
            <p>use the Website and services;</p>
            <p>download certain content or products from our services;</p>
            <p>enter contests or sweepstakes;</p>
            <p>fill out and submit any form;</p>
            <p>
              have previously provided us with personal information prior to this Privacy Policy or
              last updates coming into effect;
            </p>
            <p>subscribe to our email list, and/or service updates;</p>
            <p>attend our hosted events;</p>
            <p>request support;</p>
            <p>
              contact us directly in person or via any medium, including but not limited to by mail,
              telephone, and commercial electronic messages;
            </p>
            <p>
              communicate with us for any matters and interact with or browse the Website generally.
            </p>
            <h1>1.1.2 Personal information that we may receive includes, but is not limited to:</h1>
            <p>contact information such as name and email address;</p>
            <p>billing information;</p>
            <p>voice and image (in any content you upload);</p>
            <p>more detailed personal preferences;</p>
            <p>more detailed contact preferences.</p>
            <p>
              1.1.3 WRewards may receive this data from you when you manually enter such data, or we
              may receive such data from third parties. We may combine such data.{" "}
            </p>
            <p>
              1.1.4 By giving us this data, you consent to this data being collected, used,
              disclosed, transferred as described in this Privacy Policy.
            </p>
          </div>
          <div>
            <h1>Data that we collect automatically</h1>
            <p>
              1.2.1 We collect data from every visitor and customer of our Website and services, in
              particular, we automatically collect data about your visit to the Website, your usage
              of our services, and your browsing activities. This anonymized information may include
              IP address, browser type, browser language, cookies data, performance specifications
              of the customer’s hardware and software, date and time of access to the Website, other
              information about how you interacted with our Website and our services.
            </p>
          </div>
          <div>
            <h1>Data from your use of the Website and our products</h1>
            <p>
              1.3.1 We may receive data about how and when you use the Website, store it in log
              files or other types of files associated with your account, and link it to other
              information we collect about you. This data may include, for example, your IP address,
              time, date, browser used, and actions you have taken within the Website. This type of
              data helps us to improve our Website, services, and products for both you and all of
              our customers.
            </p>
          </div>
          <div>
            <h1>Data from third party sources</h1>
            <p>
              1.4.1 We may obtain additional information from third parties sources, such as
              advertisers, games or services you use, or social media networks (such as Instagram,
              Facebook) for which you have approved our access. When you access our services through
              social media networks, or when you connect our services to social media networks, you
              are authorizing WRewards to collect, store, and use such additional information and
              content in accordance with this Privacy Policy. We use this information to supplement
              the information we collect about you in order to provide more relevant, safer
              experiences for you and improve our services, analytics, and advertising. If we
              combine or associate information from other sources with information that we collect
              through our services, we will treat the combined information in accordance with this
              Privacy Policy.
            </p>
          </div>
          <div>
            <h1>Cookies and tracking</h1>
            <p>
              1.5.1 Cookies are small data files that are placed on your computer or mobile device
              when you visit a website. Website owners use cookies to make their websites operate,
              improve functionality and user experience, as well as to provide reporting
              information.
            </p>
            <p>
              1.5.2 We may set our own cookies and use third parties cookies (e.g. for advertising,
              statistics, and analytics).
            </p>
            <p>1.5.3 We use different types of cookies, including:</p>
            <p>
              Essential website cookies: these are important cookies as they are necessary to
              provide you with services available through our Website, such as access to secure
              areas.
            </p>
            <p>
              Performance and functionality cookies: these cookies are necessary to enhance the
              performance and functionality of our Website but are non-essential to their use.
              However, without these cookies, certain functionality may become unavailable.
            </p>
            <p>
              Analytics and customization cookies: these cookies collect information that is used
              either in aggregate form to help us understand how our Website is being used or how
              effective our marketing campaigns are, to help us customize our Website for you in
              order to enhance your experience, or to personalize our content and ads.
            </p>
            <p>
              Advertising cookies: these cookies are used to make advertising messages more relevant
              to you. They perform functions like preventing the same ad from continuously
              reappearing, ensuring that ads are properly displayed, and in some cases selecting
              advertisements that are based on your interests. Please read the following link to
              know more about online advertising:
              https://www.networkadvertising.org/understanding-online-advertising/.{" "}
            </p>
            <p>
              Social Media cookies: these cookies are placed by social media plugins, and other
              tools meant to provide or improve the content on a website (for example, services that
              allow the playing of video files, or that create comments sections).{" "}
            </p>
            <p>
              1.5.4 You may opt out from cookies at any time by customizing your cookie preferences.
              However, in some cases, we will not be able to provide you with all services.
            </p>
          </div>
          <div>
            <h1>Opting-Out</h1>
            <p>
              1.6.1 You may decline to have your personal information collected via third party
              tracking technologies by navigating to the settings feature in your browser and
              declining all third party cookies or declining third party cookies from specific
              sites, or, for mobile, limiting ad tracking or resetting the advertised identifier via
              the privacy settings on your mobile device.
            </p>
            <p>
              1.6.2 You can use the following third party tools to decline the collection and use of
              information for the purpose of serving you interest based advertising:
            </p>
            <p>http://www.networkadvertising.org/choices/ </p>
            <p>http://www.youronlinechoices.com/ </p>
            <p>
              http://optout.aboutads.info/?c=2 HYPERLINK
              &quot;http://optout.aboutads.info/?c=2&amp;lang=EN&quot; HYPERLINK
              &quot;http://optout.aboutads.info/?c=2 HYPERLINK
              &quot;http://optout.aboutads.info/?c=2&amp;lang=EN&quot;&amp; HYPERLINK
              &quot;http://optout.aboutads.info/?c=2&amp;lang=EN&quot; HYPERLINK
              &quot;http://optout.aboutads.info/?c=2&amp;lang=EN&quot;&amp; HYPERLINK
              &quot;http://optout.aboutads.info/?c=2&amp;lang=EN&quot; HYPERLINK
              &quot;http://optout.aboutads.info/?c=2 HYPERLINK
              &quot;http://optout.aboutads.info/?c=2&amp;lang=EN&quot;&amp; HYPERLINK
              &quot;http://optout.aboutads.info/?c=2&amp;lang=EN&quot; HYPERLINK
              &quot;http://optout.aboutads.info/?c=2&amp;lang=EN&quot;
            </p>
            <p>www.allaboutcookies.org </p>
          </div>
          <div>
            <h1>2. Use of the Data</h1>
            <p>2.1. We only use your personal information for the following purposes:</p>
            <p>2.1.1 to perform transactions requested by you;</p>
            <p>
              2.1.2 to display content from external platforms and process gift claim functionality;
            </p>
            <p>2.1.3 to allow you to participate in online games, contests, or rewards programs;</p>
            <p>2.1.4 to personalize your experience when using our services;</p>
            <p>2.1.5 to maintain our relationships with you, promote WRewards;</p>
            <p>
              2.1.6 to send you informational and promotional content that you may subscribe to or
              unsubscribe;
            </p>
            <p>
              2.1.7 to communicate about our Website, products, services and provide customer care
              in response to your inquiries;
            </p>
            <p>2.1.8 to enforce compliance with the applicable law;</p>
            <p>
              2.1.9 to protect our rights and safety as well as the rights and safety of our
              customers and third parties;
            </p>
            <p>
              2.1.10 to contact you via surveys to conduct research about your opinion of our
              products;
            </p>
            <p>2.1.11 to provide information to representatives and advisors;</p>
            <p>2.1.12 to prosecute and defend a court, arbitration, or similar legal proceeding;</p>
            <p>
              2.1.13 to respond to lawful requests by public authorities, including to meet national
              security or law enforcement requirements;
            </p>
            <p>
              2.1.14 to provide suggestions about products that you may be interested in and which
              you may opt out;
            </p>
            <p>
              2.1.15 to transfer your information in the case of a sale, merger, consolidation,
              liquidation, reorganization, or acquisition.
            </p>
            <p>2.1.16 to verify if user is breaking TOS rules.</p>
          </div>
          <div>
            <h1>3. Minors</h1>
            <p>
              3.1 Minors and children under age of 18 (or of legal gambling age in your country of
              residence) are not permitted to use our Website. We do not knowingly transact or form
              any binding legal relationship with minors. If you access our Website, you represent
              that you have the legal capacity to enter into a binding agreement.
            </p>
          </div>
          <div>
            <h1>4. Sharing of Data</h1>
            <p>4.1 We do not share personal information, unless:</p>
            <p>4.1.1 Doing so is appropriate to carry out your own request;</p>
            <p>
              4.1.2 We believe it is needed to enforce our Privacy Policy, or if it is legally
              required;
            </p>
            <p>
              4.1.3 We believe it is needed to detect, prevent or address fraud, security or
              technical issues;
            </p>
            <p>4.1.4 Otherwise protect our property, legal rights, or that of others.</p>
            <p>
              4.2 We may share your information with our operating offices and in any other places
              where the parties involved in the processing are located. WRewards has in place an
              intra-group transfer agreement to safeguard these personal data transfers. If, in the
              future, we re-organise or transfer all or part of our business, we may need to
              transfer your information to new entities or third parties through which our business
              will be carried out. Depending on customer’s location, the data may be transferred to
              a country other than where the customer is located. If any such transfer takes place,
              you can contact WRewards for enquiring more details.
            </p>
            <p>
              4.3 We do not share your personal information with third parties, except for our
              service providers, such as providers of cloud services, and other information
              technology services providers, email communication software and email newsletter
              services, advertising and marketing services, payment processors, customer
              relationship management and customer support services, and web analytics services.
            </p>
            <p>
              4.4 This is the list of our third party service providers with contact and other
              details. Please contact us to receive an updated list of our third party service
              providers. PostgresSQL Database (https://www.postgresql.org/), The PostgreSQL Global
              Development Group, for storage data. Heroku (https://www.heroku.com/), a subsidiary of
              Salesforce Inc, for storage data. Twitch (https://www.twitch.tv/), Twitch Interactive,
              a subsidiary of Amazon.com Inc, used for authentication and profile building. Discord
              (https://discord.com/), Discord Inc, used for authentication and profile building.
            </p>
            <p>
              4.5 We employ and contract with people and other entities that perform certain tasks
              on our behalf and who are under our control (our “Agents”). We may need to share
              personal information with our Agents in order to provide products or services to you.
              Unless we tell you differently, our Agents do not have any right to use personal
              information or other information we share with them beyond what is necessary to assist
              us. You hereby consent to our sharing of personal information with our Agents.
            </p>
          </div>
          <div>
            <h1>5. Safeguarding your Personal Information</h1>
            <p>
              5.1 The protection of your personal information is vital to us. We take commercially
              reasonable measures to protect your personal information from loss, misuse, and
              unauthorized access, disclosure, alteration, and destruction, taking into account the
              risks involved in the processing and the nature of the personal information. These
              security measures include, but are not limited to, 2-factor authentication, SSL
              certificate for HTTPS.
            </p>
            <p>
              5.2 Our employees, contractors, and any business partners can access personal
              information on a need-to-know basis, and under strict duties of maintaining
              confidentiality. We use encryption for sensitive information and we test our system on
              a regular basis to ensure we comply with industry practices and standards. While we
              strive to use commercially acceptable means to protect your personal information, no
              method of transmission over the Internet, or method of electronic storage, is
              completely secure, and we cannot guarantee absolute security of any data.
            </p>
            <p>
              5.3 You agree to protect the security of your login information and password and not
              to transfer such information to any third party. We will not be liable to you for the
              use of your account by any third party.
            </p>
            <p>
              5.4 If you become aware of any unauthorized use of your account, you shall immediately
              notify us in writing.
            </p>
          </div>
          <div>
            <h1>6. Access to your Personal Information</h1>
            <p>
              6.1 You may access your personal information held by us to correct, update and remove
              inaccurate or incorrect data. You have the following rights:
            </p>
            <p>delete some or all personal information that we held about you;</p>
            <p>change or correct your personal information that we held about you;</p>
            <p>object to, or limit or restrict, use of your personal information;</p>
            <p>
              right to access and/or take your personal information: you can ask us for a copy of
              your personal information in machine readable form;
            </p>
            <p>access information we hold about you.</p>
          </div>
          <div>
            <h1>7. Changes to the Privacy Policy</h1>
            <p>
              7.1 We may amend this Privacy Policy from time to time. Use of information we collect
              now is subject to the Privacy Policy in effect at the time such information is used.
              If we make major changes in the way we collect or use information, we will notify you
              by posting an announcement on the Website or sending you an email.{" "}
            </p>
          </div>
          <div>
            <h1>8. Merge of Company</h1>
            <p>
              8.1 If WRewards merges with, or is acquired by, another company or organization, or
              sells all or a portion of its assets, your personal information may be disclosed to
              our advisers and any prospective purchaser or any prospective purchaser’s adviser, and
              may be among the assets transferred. However, personal information will always remain
              subject to this Privacy Policy.
            </p>
          </div>
          <div>
            <h1>9. Data Retention</h1>
            <p>
              9.1 We retain your personal information for as long as we need it to fulfil the
              purposes for which we originally collect it or as needed to provide with our services,
              except if required otherwise by law. Personal information collected for the purpose of
              the legitimate interests shall be retained as long as needed to fulfill such purposes.
              In certain cases, it is allowed to retain personal information for a longer period if
              the user has explicitly consented to such processing until the consent is withdrawn.
              In some cases, we may determine the period of data retention based on the period we
              need to access the data for the provision of services, receiving payment, or for any
              other auditing or legal purposes. Once the retention period expires, the personal
              information will be deleted without any possibility to rectify or transfer the deleted
              personal information.
            </p>
          </div>
          <div>
            <h1>10. Additional Information for California Residents</h1>
            <p>
              10.1 In this section we describe how we handle personal information of California
              residents under the California Consumer Privacy Act (“CCPA”). This clause covers
              personal information that we collect, share and use for the last 12 months.{" "}
            </p>
            <p>
              10.2 We describe the personal information that we collect in section 1 “Data
              Collected”. The section 2 “Use of the Data” contains information on how we use
              personal information.
            </p>
            <p>
              10.3 We share certain personal information in accordance with section 4 “Sharing of
              Data”. However, we do not sell your personal information to third parties.
            </p>
            <p>
              10.4 In accordance with the CCPA, California residents are entitled, in addition to
              other rights described in this Privacy Policy, to:
            </p>
            <p>
              10.4.1 Request deletion. You have the right to request deletion of your personal
              information that we collect from you;
            </p>
            <p>
              10.4.2 Request copy. You have the right to ask for a copy of all or part of personal
              information that we retain about you over the last 12 months;
            </p>
            <p>
              10.4.3 Designated agent. You are entitled to designate an agent who is able to make
              requests on your behalf. The agent should access your account to make a request.
            </p>
            <p>
              10.4.4 List of service providers. You have the right to request a list of third
              parties with whom we shared personal information (if any) and what kind of information
              we shared during the previous calendar year.
            </p>
            <p>
              10.5 If you want to exercise your rights, please contact us at support@wrewards.com.{" "}
            </p>
            <p>
              10.6 WRewards does not tolerate discrimination. The quality of our services is equal
              for all our customers, irrespective of whether you decide to exercise your rights
              under the CCPA.{" "}
            </p>
          </div>
          <div>
            <h1>11. Contact Us</h1>
            <p>
              11.1 If you have any questions about this Privacy Policy, or want to submit a written
              complaint to us about how we handle your personal information, please contact us at:
            </p>
            <p>support@wrewards.com</p>
            <p>* * *</p>
          </div>
        </PrivacyContainer>
      </Container>
    </PageBox>
  );
}
